<p-confirmDialog [style]="{ width: '450px' }" />

<p-toolbar styleClass="mb-4 gap-2 top-action-bar" [style]="{'z-index': '2'}">
    <ng-template pTemplate="left">
        <div class="flex align-items-center gap-2">
            <p-button *ngIf="developerMode" severity="secondary" label="Create Auto Renewal Jobs" class="mr-2"
                (onClick)="showAutoRenewalDialog()" />

            <p-button severity="secondary" label="Send today's pending notifications" class="mr-2"
                (onClick)="processPendingNotifications()" />
        </div>
    </ng-template>

    <ng-template pTemplate="right">
        <div class="flex align-items-center gap-2">
            <p-button label="Import Manual Jobs" icon="pi pi-upload" severity="success"
                (onClick)="showImportDialog()" />
            <p-button label="Export" icon="pi pi-download" severity="secondary" (onClick)="exportData()" />
        </div>
    </ng-template>
</p-toolbar>

<p-table [value]="data" [tableStyle]="{ 'min-width': '50rem' }" [paginator]="true" [rows]="req.pageSize"
    [first]="req.page" [showCurrentPageReport]="true" [rowHover]="true" dataKey="id" lazy="true" [totalRecords]="total"
    (onLazyLoad)="loadDataLazy($event)" [scrollable]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

    <ng-template #caption>
        <div style="display: flex; justify-content: space-between;">
            <h3 class="m-0" (dblclick)="toogleDeveloperMode()">Manage Notifications</h3>
            <div style="display: flex; gap: 0.5rem">
                <p-select [options]="notificationTypes" [(ngModel)]="req.filterByNotificationType" optionLabel="name"
                    optionValue="value" placeholder="Notification Type" class="w-full md:w-56" appendTo="body"
                    (ngModelChange)="refresh()" [showClear]="true" />

                <p-datepicker [(ngModel)]="rangeDates" selectionMode="range" [readonlyInput]="true"
                    (ngModelChange)="refresh()" appendTo="body" dateFormat="dd/mm/yy" />
            </div>
        </div>
    </ng-template>

    <ng-template #header>
        <tr>
            <th pSortableColumn="NotificationDate">
                <div class="sort-col-container">
                    <span>Scheduled Send Date <b>*</b></span>
                    <p-sortIcon field="NotificationDate" />
                </div>
            </th>
            <th pSortableColumn="Type">
                <div class="sort-col-container">
                    <span>Notification Type <b>*</b></span>
                    <p-sortIcon field="Type" />
                </div>
            </th>
            <th pSortableColumn="To">
                <div class="sort-col-container">
                    <span>To <b>*</b></span>
                    <p-sortIcon field="To" />
                </div>
            </th>
            <th pSortableColumn="DateSent">
                <div class="sort-col-container">
                    <span>Date Sent</span>
                    <p-sortIcon field="DateSent" />
                </div>
            </th>
            <th pSortableColumn="ErrorMessage">
                <div class="sort-col-container">Error Message<p-sortIcon field="ErrorMessage" />
                </div>
            </th>

            <th>Deal Id</th>
            <th>iHost Id</th>

            <th>Customer</th>
            <th>VAT</th>
            <th style="min-width: 10rem"></th>
        </tr>
    </ng-template>
    <ng-template #body let-item>
        <tr>
            <td>{{ item.notificationDate | date: 'dd/MM/yyyy' }}</td>
            <td>{{ item.type | notificationType }}</td>
            <td>{{ item.to }}</td>
            <td>{{ item.dateSent | date: 'dd/MM/yyyy hh:mm' }}</td>
            <td>{{ item.errorMessage }}</td>

            <td><a [href]="'/deals/edit/' + item.deal.crmid">{{ item.deal.crmid }}</a></td>
            <td>{{ item.deal.customer.ihostid }}</td>
            <td>{{ item.deal.customer.name }}</td>
            <td>{{ item.deal.customer.vatNumber }}</td>
            <td>
                <p-button icon="pi pi-pencil" class="mr-2" [rounded]="true" [outlined]="true"
                    (click)="editItem(item)" />
                <p-button icon="pi pi-trash" severity="danger" [rounded]="true" [outlined]="true"
                    (click)="deleteItem(item)" />
            </td>
        </tr>
    </ng-template>
</p-table>

<p-dialog header="Create Auto renewal notifications" [modal]="true" [(visible)]="autoRenewalNotificationsVisible"
    [style]="{ width: '25rem' }">
    <div class="flex flex-column items-center gap-2 mt-4 mb-8">
        <label for="integeronly">Days ahead</label>
        <p-inputNumber [(ngModel)]="autoRenewalDays" [min]="1" max="365" placeholder="Days" />
    </div>
    <div class="flex justify-end gap-2">
        <p-button label="Cancel" severity="secondary" (click)="autoRenewalNotificationsVisible = false" />
        <p-button label="Import" (click)="createAutoRenewalTasks()" />
    </div>
</p-dialog>

<p-dialog header="Import notifications from CSV" [modal]="true" [(visible)]="importDialogVisible"
    [style]="{ width: '25rem' }">
    <div class="flex items-center gap-4 mt-4 mb-8">
        <p-fileupload #fu mode="basic" chooseLabel="Choose" chooseIcon="pi pi-upload" name="csv[]" accept=".csv"
            customUpload="true" maxFileSize="1000000" (uploadHandler)="onUpload($event)" />
    </div>
    <div class="flex justify-end gap-2">
        <p-button label="Cancel" severity="secondary" (click)="importDialogVisible = false" />
        <p-button label="Import" (click)="submitUpload()" />
    </div>
</p-dialog>

<p-dialog [(visible)]="notificationModal" [style]="{ width: '450px' }" header="Edit notification Job" [modal]="true">
    <ng-template #content>
        <div class="flex flex-column gap-3 mb-2">
            <div class="flex flex-column gap-2">
                <label for="ndate" class="block font-bold">Notification Date</label>
                <p-datepicker name="ndate" [(ngModel)]="editingNotification!.notificationDate" selectionMode="single"
                    required fluid appendTo="body" dateFormat="dd/mm/yy" />
                <small class="text-red-500"
                    *ngIf="submitted && editingNotification!.notificationDate == null">Notification
                    Date is required.</small>
            </div>

            <div class="flex flex-column gap-2">
                <label for="ntype" class="block font-bold">Type</label>
                <p-select [options]="notificationTypes" [(ngModel)]="editingNotification!.type" optionLabel="name"
                    optionValue="value" placeholder="Notification Type" class="w-full md:w-56" appendTo="body" required
                    [showClear]="false" readonly="readonly" />
                <small class=" text-red-500" *ngIf="submitted && editingNotification!.type == null">Notification
                    Type is required.</small>
            </div>

            <div class="flex flex-column gap-2">
                <label for="nto" class="block font-bold">To</label>
                <input type="text" pInputText id="nto" [(ngModel)]="editingNotification!.to" required fluid />
                <small class="text-red-500" *ngIf="submitted && !editingNotification!.to">To required.</small>
            </div>

            <div class="flex flex-column gap-2">
                <label for="ndatesent" class="block font-bold">Date Sent</label>
                <p-datepicker name="ndatesent" [(ngModel)]="editingNotification!.dateSent" selectionMode="single" fluid
                    appendTo="body" dateFormat="dd/mm/yy" />
            </div>

            <div class="flex flex-column gap-2">
                <label for="nerrormessage" class="block font-bold">Error Message</label>
                <textarea type="text" pInputText id="nerrormessage" [(ngModel)]="editingNotification!.errorMessage"
                    rows="4" fluid></textarea>
            </div>
        </div>
    </ng-template>

    <ng-template #footer>
        <p-button label="Cancel" icon="pi pi-times" text (click)="notificationModal = false" />
        <p-button label="Save" icon="pi pi-check" (click)="editItemSubmit()" />
    </ng-template>
</p-dialog>